/// <reference path="third-party/jquery-1.6.3-vsdoc.js"/>
/// <reference path="~/js/api/WebAccess/WebAccess.js" />
/// <reference path="~/libs/ua-parser.js" />

/* Заглушка для старых браузеров */
if (typeof window.console == "undefined") {
  window.console = { log: function () { }, debug: function () { } };
} else if (WA.ENV.browser.name == "IE") {
  linktoOldconsole = window.console;
  window.console = {
    log: function (message) {
      //linktoOldconsole.log(typeof message)

      if (typeof message == "string") {
        linktoOldconsole.log(message);
        return;
      };

      if (typeof message == "function") {
        linktoOldconsole.log(message.toString());
        return;
      };

      if (message && typeof message == "object" && typeof message['selector'] !== 'undefined') {
        linktoOldconsole.log("Jquery object: " + message.selector);
        return;
      };

      function dir(object) {
        for (s in object) {
          linktoOldconsole.log(s + ": " + object[s].toString().trunc(100).split("\n")[0]);
        }
      }
      try {
        linktoOldconsole.log(dir(message));
      } catch (E) {
        linktoOldconsole.log(message);
      }
    }, debug: function () { }
  };
}

/* =Main============================================================================================================================================== */
function GetWSSParam(Url, IsFirstParam) {
  if (Url.toLowerCase().indexOf("wss=1") != -1) {
    return (IsFirstParam ? "?" : "&") + "wss=1";
  }
  return "";
}
// Проверяем жива ли сессия по возвращаемой странице.
function CheckForLoginPage(res) {
  // Если время жизни сессии пользователя завершилось - обновим страницу, чтобы перенаправить пользователя на страницу входа в систему
  if (res != null && (('' + res).indexOf("LoginTextBox") != -1 || (typeof res == "object" && res.Error && res.Error == "sLogin"))) {
    WA.services._isSessionAlive(475);
    //location.href = '';
    return true;
  } else {
    return false;
  }
}

function GetParamInURL(name, url) {
  //log.warn('DEPRECATED', "Function GetParamInURL is obsolete. Use class WebAccess.URL instead");
  return (new WA.URL(url)).getParam(name);
}

function ChangeParamInURL(url, param, value) {
  //log.warn('DEPRECATED', "Function ChangeParamInURL is obsolete. Use class WebAccess.URL instead");
  return (new WA.URL(url)).setParam(param, value).asString();
}

function RemoveParamInURL(url, param) {
  //log.warn('DEPRECATED', "Function RemoveParamInURL is obsolete. Use class WebAccess.URL instead");
  return (new WA.URL(url)).removeParam(param).asString();
}

function PrepareUrl(url, ParamStr) {
  var Params = ParamStr.split('&');
  var newUrl = url;
  for (var i = 0; i < Params.length; i++) {
    if (Params[i] != '') {
      if (Params[i].charAt(0) == '-') {
        newUrl = RemoveParamInURL(newUrl, Params[i].substr(1));
      } else {
        var p = Params[i].split('=');
        newUrl = ChangeParamInURL(newUrl, p[0], p[1]);
      }
    }
  }
  return newUrl;
}
function DoAction(ParamStr, NeedSubmitForm, NewFormAction, InHash) {
  setTimeout(function () {
    try {
      var Params = ParamStr.split('&');

      if (NeedSubmitForm) {
        for (var i = 0; i < Params.length; i++) {
          if (Params[i] != '') {
            if (Params[i].charAt(0) == '-') {
              $('#' + Params[i].substr(1)).val('');
            } else {
              var p = Params[i].split('=');
              $('#' + p[0]).val(p[1]);
            }
          }
        }
        var f = $('form:first');
        if (NewFormAction != null) {
          f.attr('action', NewFormAction);
        }
        f.submit();
      } else {
        var url = window.location.href;
        if (InHash != null && InHash) {
          url = GetURLHash(url);
        }
        url = PrepareUrl(url, ParamStr)

        var ActTab = $('#ActiveTab');
        if (ActTab.length == 1) {
          url = ChangeParamInURL(url, 'ActiveTab', ActTab.val());
        }

        if (InHash != null && InHash) {
          url = GetURLWithoutHash() + "#" + url;
        }
        if (!InHash && ParamStr.indexOf('#') == -1) {
          url = GetURLWithoutHash(url);
        }
        window.location.href = url;
      }
    } catch (ex) {
    }
  }, 100);
}

function GetURLHash(url) {
  log.warn('DEPRECATED', "Function GetURLHash is obsolete. Use class WebAccess.URL instead");
  return (new WA.URL(url)).getHash();
}

function GetURLWithoutHash(url) {
  log.warn('DEPRECATED', "Function GetURLWithoutHash is obsolete. Use class WebAccess.URL instead");
  return (new WA.URL(url)).asStringWithoutHash();
}

function DoActionHash(ParamStr, callback) {
  DoAction(ParamStr, false, false, true);
  callback();
}

function ReloadExtension(ext) {
  log.warn('DEPRECATED', "Function ReloadExtension is obsolete. Use class WebAccess.extensions.current.reload() instead");
  ShowTopSpinner(L('MSG_RELOADING_EXTENSION'));
  CallService("/Administration.asmx/ReloadExtension", { ExtensionName: ext }, function (res) {
    if (res.Success) {
      HideTopSpinner('', 0);
      ShowMessage(L('MSG_EXT_RELOADED'), L('SUCCESS'), function () { location.href = location.href; });
    } else {
      ShowError(res.Error);
    }
  });
}

function HintShow(msg) {
  ErrorShow(msg, false);
}
function WrnShow(msg) {
  ErrorShow(msg, true);
}

var g_prevFormVal;

function SerializeForm(containerSelector) {
  if (WA.isMobile() || !WA.CR.form.isExist()) {
    return __legacy_serializeForm(containerSelector);
  } else {
    return WA.CR.form.asString();
  }
}

function __legacy_serializeForm(containerSelector) {
  var jContainer;

  if (containerSelector) {
    jContainer = $(containerSelector);
  } else {
    jContainer = $('body');
  }

  var r = '';
  var cardForm = jContainer.find('.CardForm');
  if (cardForm.length == 0) {
    r = jContainer.find('input[type=text]:visible,input[type=checkbox]:visible,input[type=radio]:visible,select:visible,textarea:visible');
  } else {
    // На скрытых вкладках тоже ищем.
    r = cardForm.find('input[type=text],input[type=checkbox],input[type=radio],select,textarea');
  }
  //Добавляем скрытые поля и ИД реквизита "Выбор из справочника" для инпутов, которые видимы.
  var hidd = jContainer.find('input[id^=hSelID_]').filter(function () {
    var dispInp = $('#' + $(this).attr('name'));
    if (cardForm.length == 0) {
      dispInp = dispInp.filter(':visible');
    }
    return dispInp.length > 0;
  });
  r = r.serialize() + '&' + hidd.serialize();

  //Добавляем информацию о вложениях для ЗЗУ
  var jAttachments = $('#main_container').find('.attachments_td');
  if (jAttachments.find('#pnlEmpty').length == 0) {
    var AttachmentStr = [];
    jAttachments.find('[data-name="ObjectListItem"]').each(function () {
      var kind = $(this).attr("kind");
      var additionalAttachmentInfo = "";
      if (kind === 'Ref') {
        additionalAttachmentInfo = "_" + $(this).attr("compcode");
      }
      AttachmentStr.push(kind + "_" + $(this).attr("id") + additionalAttachmentInfo);
    })
    r += '&Attachments=' + AttachmentStr.join(';');
  }
  return r;
}

var g_formContainerSelector;
function BindBeforeUnload() {
  var containerSelector = g_formContainerSelector; // для сужения области мониторинга изменений (например, в ЗЗУ галочка во вложениях тоже попадается) (#100264).
  var initDef;

  // В мобильной версии нет Form, поэтому этот механихм должен работать и отсылки на WA.Init.
  if (WA.isMobile()) {
    initDef = $.Deferred();
    initDef.resolve();
  } else {
    initDef = WA.Init;
  }

  initDef.done(function () {
    g_prevFormVal = SerializeForm(containerSelector);

    WA.CR.window.bind('beforeClose', function () {
      if ((SerializeForm(containerSelector) != g_prevFormVal) || (g_RightsChanged == 1)) {
        return L('DATA_DIDNT_SAVE');
      }
      return false;
    });
  });
}
function UnbindBeforeUnload() {
  WA.CR.window.unbind('beforeClose');
}
function CloseWindow() {
  WA.CR.window.close();
}

/* =================================================================================================================================================== */

/* =Задания=========================================================================================================================================== */
function ShowJobCard() {
  DoAction('view=JobCard&-op&-val', false);
}
function ShowJobAttachments() {
  DoAction('view=attach&-op&-val', false);
}
function ShowJobState() {
  DoAction('view=state&-op&-val', false);
}
function GetJobEdit() {
  var mode = GetParamInURL("mode");
  if (mode.toLowerCase() == "edit") {
    //Шамов А.: Сделано для оптимизации. Если режим не указан, в серверном коде будет отправлен запрос для получения типа задания,
    // он нам нужен что бы задания-контроль всегда открывать заблокированными.
    if (WA.current.Kind === JOB_KIND.CONTROLJOB) {
      DoAction("-mode", false);
    } else {
      DoAction("mode=read", false);
    }
  } else {
    DoAction("mode=edit", false);
  }
}
function SaveInBaseJob(needToClose) {
  UnbindBeforeUnload();
  if (needToClose)
    DoAction('__POSTBACK_ACTION=SaveAndCloseJob', true);
  else
    DoAction('__POSTBACK_ACTION=SaveTextJob', true);
}

function SetJobApproveParams() {
  UnbindBeforeUnload();
  DoAction('__POSTBACK_ACTION=SaveAskParams', true);
}
function CancelSetJobApproveParams() {
  DoAction('view=JobCard&-op&-mode&-val', false);
}
function BaseAcceptContolJob(r) {
  if (r != null) {
    $("#__RESULT_VAR").val(r);
  }
  DoAction('__POSTBACK_ACTION=AcceptWf', true);
}
function ResumeContolJob() {
  UnbindBeforeUnload();
  DoAction('__POSTBACK_ACTION=ResumeWf', true);
}

function CreateJobSubTask() {
  window.open(PrepareUrl(location.href, 'view=JobCard&op=newsubtask'));
}
function CloseBaseJobWindow(jobId) {
  window.onunload = function () { FreeJob(jobId); }
}
function FreeJob(JobID) {
  var R;
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/Job.asmx/FreeJob" + WSSParam,
    data: "{'JobID':'" + JobID + "'}",
    async: false,
    success: function (res) {
      R = res.d;
    }
  });
  CheckForLoginPage(R);
  return R;
}
/* =================================================================================================================================================== */

/* =Задача============================================================================================================================================ */
function ShowTaskCard() {
  DoAction('-view&-op&-showall', false);
}
function ShowAttachments() {
  DoAction('view=attach&-op&-showall', false);
}
function ShowState() {
  DoAction('view=state&-op&-showall', false);
}
function ShowTaskHistory() {
  DoAction('view=TaskHistory&-op&-ver&-showall', false);
}

function StartTask() {

  if (!$("div[name='StartTask']").hasClass("disabled")) {
    // После клика на кнопку "Старт" лочим тулбар.
    $("#toolbar_container").find(".toolbar_item").addClass("disabled");

    var dateInput = $('.dateField').first();
    // проверку на корректность даты не делаем т.к. в SetValidDate устанавливается всегда валидная дата при любом изменени поля для даты
    if (dateInput.length > 0 && (typeof dateInput.data('selDate')) != 'undefined' && dateInput.data('selDate') != null) {
      var d = dateInput.data('selDate');
      // если в поле ввода нет пробела, то срок выполнения ставим на конец суток, чтобы корректно сравнивать с актуальной датой
      if (dateInput.val().indexOf(' ') == -1) {
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
      }
      var difference = ($.now() - d.getTime());
      if (difference > 0) {
        ShowTaskDeadlineActualizeDialog(
          function () { $("#toolbar_container").find(".toolbar_item").removeClass("disabled"); }
        );
      }
      else {
        UnbindBeforeUnload();
        DoAction('__POSTBACK_ACTION=StartTask', true);
      }
    }
    else {
      UnbindBeforeUnload();
      DoAction('__POSTBACK_ACTION=StartTask', true);
    }
  }
}

function AbortTask() {
  DoAction('__POSTBACK_ACTION=AbortTask', true);
}
function RestartTask() {
  DoAction('__POSTBACK_ACTION=RestartTask', true);
}
function RestoreTask() {
  DoAction('__POSTBACK_ACTION=RestoreTask', true);
}
function EnterEditMode() {
  var mode = GetParamInURL("mode");
  if (mode.toLowerCase() == "edit") {
    DoAction("mode=read", false);
  }
  else {
    DoAction("mode=edit", false);
  }
}
function SaveInTask() {
  UnbindBeforeUnload();
  DoAction('__POSTBACK_ACTION=SaveTask', true);
}
function SaveAndCloseTask() {
  UnbindBeforeUnload();
  DoAction('__POSTBACK_ACTION=SaveAndCloseTask', true);
}
function CreateSubTask() {
  window.open(PrepareUrl(location.href, 'mode=newsubtask&-view&-op&-showall'));
}
function DoImportance(el, val, css) {
  UnbindBeforeUnload();
  MakeRequestImportance(GetParamInURL('id'), val, function (res) {
    if (res.d) {
      if ($(el).hasClass(css)) {
        $(el).removeClass(css);
      } else {
        $(el).addClass(css);
      }
      if (val == 'High') {
        $(el).next().removeClass(css);
      } else if (val = 'Low') {
        $(el).prev().removeClass(css);
      }
    }
  });
}
function MakeRequestImportance(TaskID, Value, CallbackFunc) {
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/Task.asmx/DoImportance" + WSSParam,
    data: "{'TaskID':'" + TaskID + "', 'Value':'" + Value + "'}",
    success: function (res) {
      if (!CheckForLoginPage(res.d)) {
        CallbackFunc(res);
      }
    }
  });
}
function BaseChangeStandartRoute(el, css) {
  if (!$(el).hasClass(css)) {
    DoAction('op=ChangeRoute', false);
  } else {
    ShowTaskCard();
  }
}
function LoadRouteParams(route_id) {
  DoAction('__POSTBACK_ACTION=ChangeSelRoute', true);
}
function StandartRouteSelected() {
  UnbindBeforeUnload();
  DoAction('__POSTBACK_ACTION=SaveAskParams', true, RemoveParamInURL($('form:first').attr('action'), 'isNew'));
}
function BaseCancelStandartRoute(callback) {
  UnbindBeforeUnload();
  if (GetParamInURL('isNew') == '1') {
    callback();
  } else {
    DoAction('__POSTBACK_ACTION=ClearSelRoute', true);
  }
}
function CloseBaseTaskWindow(taskId) {
  window.onunload = function () { FreeTask(taskId); }
}
function FreeTask(TaskID) {
  var R;
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/Task.asmx/FreeTask" + WSSParam,
    data: "{'TaskID':'" + TaskID + "'}",
    async: false,
    success: function (res) {
      R = res.d;
    }
  });
  CheckForLoginPage(R);
  return R;
}

/* =================================================================================================================================================== */

/* =Документ========================================================================================================================================== */
//Панель представлений.
function ShowEDocCard() {
  DoAction('view=ShowEDoc&-op&-ver&-showall', false);
}
function ShowVersionList() {
  DoAction('view=ShowVerList&-op&-ver&-showall', false);
}
function ShowRightsList() {
  DoAction('view=RightsList&-op&-ver&-showall', false);
}
function ShowSignInfo() {
  DoAction('view=SignInfoEDoc&-op&-ver&-showall', false);
}
function ShowBoundEDocs() {
  DoAction('view=BoundEDocs&-op&-ver&-showall', false);
}
function ShowEDocHistory() {
  DoAction('view=EDocHistory&-op&-ver&-showall', false);
}
function ShowEDocPreview() {
  DoAction('view=EDocPreview&-op&-ver&-showall', false);
}
// Тулбар
function EditModeForEDoc() {
  var mode = GetParamInURL("mode");
  if (mode.toLowerCase() == "edit" || mode.toLowerCase() == "new") {
    DoAction("mode=read", false);
  } else {
    DoAction("mode=edit", false);
  }
}

/**
* Обновляет родительское окно.
* @global
* @function UpdateOpenerWindow
* @deprecated
*/

/**
* Обновляет родительское окно при закрытии текущего.
* @global
* @function UpdateOpenerWindowOnClose
* @deprecated
*/

function SaveInDoc(callback) {
  //UnbindBeforeUnload();
  ShowTopSpinner(L('EDOC_SAVING'));

  var isNeedAddInAttachments = false;

  var data = { DocumentID: parseInt(GetParamInURL('id'), 10), Password: '', EncryptionKey: '' };
  data.receiverObjectLink = null;
  var currentUrl = new WA.URL();
  if (currentUrl.getParam('mode').toLowerCase() === 'new') {
    if (currentUrl.getParam('cwid') != '') {
      var type = currentUrl.getParam('cwtype') === 'task' ? OBJECT_TYPE.TASK : OBJECT_TYPE.JOB;
      data.receiverObjectLink = new WA.Link(parseInt(currentUrl.getParam('cwid'), 10), type);
      isNeedAddInAttachments = true;
    } else {
      if (GetParamInURL('folder') != '') {
        data.receiverObjectLink = new WA.Link(parseInt(currentUrl.getParam('folder'), 10), OBJECT_TYPE.FOLDER);
      }
    }
  }
  var view = GetParamInURL('view');
  switch (view.toUpperCase()) {
    case "RIGHTSLIST":
      SaveRights(function (res) {
        if (res.Success) {
          save_ok();
        } else {
          save_fail(res.Error);
        }
      });
      break;
    case "":
    case "SHOWEDOC":
    case "CARD":
      WA.CR.form.saveAndAttach(function (ok, warningMessage) {
        if (ok) save_ok(warningMessage);
        else save_fail();
      }, true, data.receiverObjectLink);
      break;
    case "SHOWVERLIST":
      var edocid = WA.current.ID;
      var stage = $('.State_Table').find('input[id$="EdocLifeStage"]').val();
      WA.SRV.call("/EDocument.asmx/ChangeEdocLifeStage", {
        EDocID: edocid,
        Stage: stage
      }).done(function (model) {
        save_ok();
      }).fail(function (error) {
        save_fail(error);
      });
      break;
    default:
      save(data);
  }

  function save_ok(warningMessage) {
    if (WA.CMP.NTF.InlineHint) {
      WA.CMP.NTF.InlineHint.hideAll();
      if (warningMessage) WA.CR.inlineHint.showWarning(warningMessage);
    }

    WA.CR.window.reloadParentWindowOnClose();

    if (window.opener) {
      try {
        // Вставка ссылки на документ во вложения.
        if (isNeedAddInAttachments && (window.opener.WA.getLocation() === 'task' || window.opener.WA.getLocation() === 'job')) {
          window.opener.AddAttachment(new WA.Link(WA.CR.ID, OBJECT_TYPE.EDOCUMENT));
        }
        if (window.opener.NeedUpdateOnChildClose) {
          // хак для обновления проводника, потому что карточка документа создается из эксплорера из айфрейма. поэтому здесь window.parent - пустой и нельзя у него вызвать ReloadExplorer
          //window.open("javascript:void(0)", "explorer").location = window.open("javascript:void(0)", "explorer").location;
          this.focus();
        }
      }
      catch (e) { }
    }

    function CallbackOrAction() {
      if (callback) callback();
      else {
        UnbindBeforeUnload(); // отключаем проверку когда уже все нормально сохранилось
        DoAction('mode=edit', false);
      }
    }

    if (GetParamInURL('mode').toLowerCase() == 'new') {
      if ($('html').hasClass('mobile')) {
        var id = GetParamInURL('id');
        var f = $("form:first");
        var url = f.attr('action');
        url = ChangeParamInURL(url, 'view', 'Card');
        url = ChangeParamInURL(url, 'id', id);
        url = RemoveParamInURL(url, 'mode');
        f.attr('action', url);
        f.submit();
      }
      else {
        ShowSetDocumentRightsDialog(CallbackOrAction);
      }
    }
    else {
      CallbackOrAction();
    }
  }

  function save_fail(err) {
    HideTopSpinner();
    if (err) {
      ErrorShow(err, true);
    }
  }

  function save(data) {
    CallService("/Document.asmx/Save", data, function (res) {
      if (!res.Success) {
        save_fail(res.Error);
      } else {
        HideTopSpinner();
        HideTopSpinner(L("EDOC_SAVE_COMPLETE"), 2000);
        save_ok();
      }
    });
  }
}

function SaveWithEncoding(save, data) {
  var passwordChkbox = $('#EncryptWithPasswordCheckBox');
  var certChkBox = $('#EncryptWithCertCheckBox');
  var onError = function (error) { certChkBox.attr('checked', true); passwordChkbox.data('password', null); HideTopSpinner(); ShowError(error); };
  data.EncryptionKey = '';
  if (passwordChkbox.is(':checked') && !!!passwordChkbox.data('password') && passwordChkbox.data('password') != "") {
    var dialog = RequestPasswordForDecryption('', function (password) {
      data.Password = password;
      if (WA.Document.Encoding % 2 == 1) {
        //FIXME: переделать на WA.agent.getDocumentDecryptionKey
        GetEncryptionKeyForDoc(WA.Document.ID, WA.Document.Encoding, WA.Document.PluginName, password, function (encryptionKey) {
          data.EncryptionKey = encryptionKey;
          save(data);
        }, onError);
        return;
      }
      save(data);
    });
    if (!!dialog) dialog.cancel = dialog.onClose = function () { ShowTopSpinner('', true).stop(); };
    return;
  }
  if (!!passwordChkbox.data('password') && passwordChkbox.data('password') != '') data.Password = passwordChkbox.data('password');
  if (WA.Document.Encoding % 2 == 1) {
    //FIXME: переделать на WA.agent.getDocumentDecryptionKey
    GetEncryptionKeyForDoc(WA.Document.ID, WA.Document.Encoding, WA.Document.PluginName, data.Password, function (encryptionKey) {
      data.EncryptionKey = encryptionKey;
      save(data);
    }, onError);
    return;
  }
  save(data);
}

function GetEncryptionKeyForDoc(docID, encoding, pluginName, password, onSuccess, onError) {
  RequestToken(TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY, function (token) {
    WebAccess.agent.transmitRequest("getdocdecryptedkey", "edmsplugin",
      {
        "DocID": docID,
        "Version": 0,
        "Token": token,
        "EncodeType": encoding,
        "EncryptionPluginName": pluginName,
        "Password": password
      }).done(function (response) {
        if (onSuccess) { onSuccess(response.result); }
      }).fail(function (response) {
        if (onError) onError(response.message);
      });
  }, docID, 0);
}

function SaveRights(callback, error) {
  var src = $('#__SELECTED_USERS').val();
  var res = [];
  var rightsJson = '';
  var rightsChanged = false;

  //Проверка наличия полных прав
  if (!IsRightsListValid()) {
    HideTopSpinner();
    return ShowInfo(L("WARN_EMPRY_RIGHTS_ISNOT_VALID"));
  }

  var currentRights = $('#__CURRENT_USERS_RIGHTS');
  if (!!!currentRights.data('changed') || currentRights.data('changed') == '0') currentRights.data('changed', CheckRightsHaveChanged(currentRights.val(), src) ? '1' : '0');
  var newEcoding = GetDocNewEncoding($('#EncryptWithPasswordCheckBox'), $('#EncryptWithCertCheckBox'));

  if (currentRights.data('changed') == '1' || (newEcoding > 0 && src.indexOf('g_') != -1)) {
    var rightRecords = src.split(';');
    for (var i = 0; i < rightRecords.length; i++) {
      var rec = $.trim(rightRecords[i]);
      if (rec) {
        var parts = rec.split('-');
        var id = parts[0];
        var right = [16, 8, 4][parseInt(parts[1], 10)]; // 0 -> 16 (full), 1 -> 8 (change), 2 -> 4 (view)
        var isGroup = false;
        if (id.indexOf('g_') == 0) {
          id = id.substr(2);
          if (newEcoding == 0) {
            isGroup = true;
          }
          else {
            RequestActionWithGroup(id, parts[1], function () { SaveRights(callback, error); });
            return;
          }
        }
        res.push({ UserID: +id, IsGroup: isGroup, RightType: right });
      }
    }
    rightsJson = $.toJSON(res);
    rightsChanged = true;
  }
  var rightsDelegationSetting = GetRightsDelegationSettingValue();
  var rightsDelegationInitVal = $('#RightsDelegationCheckBox').data('initval') == 1;
  var rightsDelegationChanged = rightsDelegationSetting != rightsDelegationInitVal;
  SetEncryptionForDocument({ RightsJSON: rightsJson, RightsDelegationTurnedOn: rightsDelegationSetting }, rightsChanged || rightsDelegationChanged, callback);
}

function RequestActionWithGroup(groupID, accessLevel, onActionSelected) {
  var actions = [L('ADD_GROUP_AND_SUBGROUPS_USERS'), L('ADD_GROUP_USERS_ONLY'), L('REMOVE_GROUP_FROM_ACCESS_RIGHTS')];
  var html = '<div style="margin-bottom:1em;">' + L('CANNOT_USE_USERGROUPS_WITH_ENCRYPTION') + '</div>';
  html += '<div id="actionOnDocumentForm">';
  html += '<div id="actionOptionsGroup">';
  html += '<div id="optionsTitle">' + L('LOCAL_COPY_OPTIONS') + '</div>';
  html += '<div id="actionOptions">';
  for (var i = 0; i < actions.length; i++) {
    var needCheck = (i == 0);
    html += '<div class="option">'
      + '<input id="option-' + i + '" type="radio" name="actions"' + (needCheck ? 'checked ' : '') + ' opcode="' + i + '" />'
      + '<label for="option-' + i + '">'
      + actions[i] + '</label></div>';
  }
  html += '</div></div></div>';

  var mbox = new WA.CMP.dialogs.MessageBox();
  mbox.width = 450;
  mbox
    .okCancelButtons(function () {
      var opcode = $('#actionOptions').find('input:checked').attr('opcode');
      switch (opcode) {
        case "0": OpenUpUserGroup(groupID, accessLevel, true, onActionSelected); break;
        case "1": OpenUpUserGroup(groupID, accessLevel, false, onActionSelected); break;
        case "2":
          $('tr#current_g_' + groupID + ',tr#new_g_' + groupID).find('.rights-table__delete-row').click();
          if (onActionSelected) onActionSelected();
          break;
      }
    }, function () { HideTopSpinner(); });
  var groupName = $('tr#current_g_' + groupID + ',tr#new_g_' + groupID).children('.Rights_Table_td').children().text();
  mbox.showQuestion(L('ADD_GROUP_USERS_TO_ENCODED_OBJECT_RIGHTS', groupName), html);
}

function OpenUpUserGroup(groupID, accessLevel, needOpenSubgroups, onGroupOpened) {
  WA.SRV.call('/UserList.asmx/GetUsersInGroup', { 'GroupID': groupID, 'NeedProcessSubGroups': needOpenSubgroups, 'RenderItems': true })//'ObjectID': WA.current.ID, 'ObjectType': 1, 'Filtrator': '' })
    .success(function (items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (AddUserByDiv($(item.text)[0])) {
          // устанавливаем нужные права только у добавленных пользователей
          $('tr#current_' + item.id + ',tr#new_' + item.id).children('.rights-table__column_current-rights').find('[name=' + accessLevel + ']').click();
        }
      }
      // удаляем группу из таблицы
      $('tr#current_g_' + groupID + ',tr#new_g_' + groupID).find('.rights-table__delete-row').click();
      if (onGroupOpened) onGroupOpened();
    })
    .fail(function (error) {
      var severity = (error.Severity !== "-1" ? Number(error.Severity) : undefined);
      WA.CR.inlineHint.show(error, undefined, severity);
    });
}

function GetRightsDelegationSettingValue() {
  var RightsDelegationCheckBoxVal = false;
  var RightsDelegationCheckBox = $('#RightsDelegationCheckBox');
  if (RightsDelegationCheckBox.length) { RightsDelegationCheckBoxVal = RightsDelegationCheckBox.is(':checked'); }
  return RightsDelegationCheckBoxVal;
}

function CheckRightsHaveChanged(oldValue, newValue) {
  if (oldValue.length != newValue.length) return true;
  if (oldValue[oldValue.length - 1] == ';') oldValue = oldValue.substr(0, oldValue.length - 1);
  if (newValue[newValue.length - 1] == ';') newValue = newValue.substr(0, newValue.length - 1);
  if (oldValue.split(';').sort().join(';') != newValue.split(';').sort().join(';')) return true;
  return false;
}

function SetEncryptionForDocument(RightsObject, RightsChanged, OnEncryptionSet) {
  var passwordCheckBox = $('#EncryptWithPasswordCheckBox');
  var certCheckBox = $('#EncryptWithCertCheckBox');
  var password = !!passwordCheckBox.data('password') ? passwordCheckBox.data('password') : '';
  var currentEncoding = WA.Document.Encoding;
  var newEncoding = GetDocNewEncoding(passwordCheckBox, certCheckBox);
  var encryptionKey = "";
  if (currentEncoding != newEncoding || RightsChanged) {
    RightsObject.EncodingType = newEncoding;
    RightsObject.Password = password;
    SaveWithEncoding(function (res) {
      RequestSetEncryption(currentEncoding, res, OnEncryptionSet);
    }, RightsObject);
    return;
  }
  if (OnEncryptionSet) OnEncryptionSet({ Success: true, EncodingChanged: RightsChanged });
}

function RequestSetEncryption(currentEncoding, RightsObject, OnEncryptionSet) {
  RightsObject.DocumentID = WA.Document.ID;
  WA.services.call("/Document.asmx/SetEncryption", RightsObject) //{ "DocumentID": WA.Document.ID, "EncodingType": newEncoding, "Password": password, "EncryptionKey": encryptionKey })
    .success(
    function (res) {
      //WA.current.toolBar.buttons.ChangeDocPassword.enable();
      var encChanged = (WA.Document.Encoding != RightsObject.EncodingType && $('#__CURRENT_USERS_RIGHTS').data('changed') == '1');
      WA.Document.Encoding = RightsObject.EncodingType;
      HideTopSpinner(L("EDOC_SAVE_COMPLETE"), 2000);
      if (OnEncryptionSet) OnEncryptionSet({ Success: true, EncodingChanged: encChanged });
    })
    .fail(
    function (res) {
      var passwordCheckBox = $('#EncryptWithPasswordCheckBox');
      passwordCheckBox.data('password', null);
      if (currentEncoding < 2) passwordCheckBox.removeAttr("checked");
      else passwordCheckBox.attr('checked', true);
      if (currentEncoding % 2 == 1) $('#EncryptWithCertCheckBox').attr("checked");
      else $('#EncryptWithCertCheckBox').removeAttr("checked");
      if (OnEncryptionSet) OnEncryptionSet({ Success: false, Error: res });
      //WA.current.toolBar.buttons.ChangeDocPassword.disable();
    });
  return;
}

function GetDocNewEncoding(passwordCheckBox, certCheckBox) {
  var encoding = 0;
  var certEncryptEnabled = certCheckBox.is(':checked');
  if (certEncryptEnabled) {
    encoding++;
  }
  if (passwordCheckBox.is(':checked')) {
    encoding = 2;
    if (certEncryptEnabled) {
      encoding++;
    }
  }
  return encoding;
}

function ChangeTabDoc(tabName) {
  function ChangeTab() {
    ShowTopSpinner(L("PLEASE_WAIT"), false);
    if (tabName == "close") {
      SaveInDoc(function () {
        CloseDocWindow(L("DATA_DIDNT_SAVE"), GetParamInURL("id"));
      });
    } else {
      var mode = GetParamInURL("mode").toLowerCase();
      if (mode == "export" || mode == "explock" || mode == "editlock") { // если мы попали сюда при неудачной попытке экспорта, то уберем mode
        DoAction('view=' + tabName + '&-op&-val&-ver&-ShowAll&-mode', false);
      } else {
        DoAction('view=' + tabName + '&-op&-val&-ver&-ShowAll', false);
      }
    }
  }

  ChangeTab();
}
function UndoEDoc() {
  UnbindBeforeUnload();
  DoAction('__POSTBACK_ACTION=UndoEDoc', true);
}

function SaveAndCloseEDoc() {
  UnbindBeforeUnload();
  SaveInDoc(function () {
    CloseDocWindow(L("DATA_DIDNT_SAVE"), GetParamInURL("id"));
    clearTimeout(window.opener.timeoutHandler);
  });
}

// Блокировка/разблокировка документа (в тулбаре).
function LockUnlock() {

  var EDocID = GetParamInURL("id");
  var isLocked = $("#islocked").val() == "1";
  var jButton = $("[name=LockUnlock]");

  ShowTopSpinner(!isLocked ? L("EDOC_LOCKING") : L("EDOC_UNLOCKING"));

  CallService(isLocked ? "/Document.asmx/Unlock" : "/Document.asmx/Lock", { DocumentID: EDocID, UseGlobalLock: false }, function (result) {
    if (result.Success) {
      var toastMsg = new WA.CMP.notifications.Toast();
      var jIsLocked = $("#islocked");

      if ($("#islocked").val() == "0") {
        jButton.find("use").attr("xlink:href", "#documentUnblock-20");
        jButton.find(".toolbar-item__title").html(L("TOOLBAR_UNLOCK_EDOC"));
        jIsLocked.val(1);
        toastMsg.showSuccess(L("DOC_SUCCESS_LOCK"));
      } else {
        jButton.find("use").attr("xlink:href", "#documentBlock-20");
        jButton.find(".toolbar-item__title").html(L("TOOLBAR_LOCK_EDOC"));
        jIsLocked.val(0);
        toastMsg.showSuccess(L("DOC_SUCCESS_UNLOCK"));
        WA.CR.inlineHint.hide();
      }
      HideTopSpinner('', 0);

      window.location.href = ChangeParamInURL(window.location.href, "Parent", "Doc");
      //$("form:first").submit();
    } else {
      ErrorShow(result.Error, false);
      HideTopSpinner('', 0);
    }
  }, function (_1, _2, err) {
    ErrorShow(err, true);
    HideTopSpinner('', 0);
  });

  //CallService("/EDocument.asmx/DocLockUnlock", { EDocID: EDocID, Lock: !isLocked }, function (result) {
  //  if (result.Success) {
  //    if ($("#islocked").val() == "1") {
  //      p.addClass("Doc/UnlockDocument.png").removeClass("Doc/LockDocument.png");
  //      p.next("span").html(L("TOOLBAR_UNLOCK_EDOC"));
  //    }

  //    if ($("#islocked").val() == "0") {
  //      p.addClass("Doc/LockDocument.png").removeClass("Doc/UnlockDocument.png");
  //      p.next("span").html(L("TOOLBAR_LOCK_EDOC"));
  //    }

  //    window.location.href = ChangeParamInURL(window.location.href, "Parent", "Doc");
  //    //$("form:first").submit();
  //  } else {
  //    ErrorShow(result.Error, false);
  //    HideTopSpinner('', 0);
  //  }
  //}, function (_1, _2, err) {
  //  ErrorShow(err, true);
  //  HideTopSpinner('', 0);
  //});
}
function DocSendAsAttachment() {
  if (/\/pda\//.test(location.pathname))
    DoAction('op=SendAsAttach', false);
  else
    window.open(PrepareUrl(location.href, 'op=SendAsAttach'));
}
// Экспорт
function Export(id, selectId, checkedId, inNewWindow) {
  UnbindBeforeUnload();
  var VerNumber = $("#" + selectId + " option:selected").val();
  var url;
  var WSSParam = GetWSSParam(location.href, false);
  if ($("#" + checkedId).is(':checked')) { url = "/Doc.aspx?ID=" + id + "&view=ShowVerList&ver=" + VerNumber + "&mode=ExpLock" + WSSParam; }
  else { url = "/Doc.aspx?ID=" + id + "&view=ShowVerList&ver=" + VerNumber + "&mode=Export" + WSSParam; };
  if (inNewWindow) {
    window.open(url, "VersionBody", "");
    CloseExportDlg();
  } else {
    location.href = url;
    /* Делать нельзя, т.к. валиться IEMobile.
    setTimeout('CloseExportDlg()', 1000);*/
  }
}
function CloseExportDlg() {
  UnbindBeforeUnload();
  var EDocID = GetParamInURL("id");
  FreeEDoc(EDocID);
  if (document.referrer.toLowerCase().indexOf("explorer.aspx") != -1) {
    window.close();
  } else {
    var url = window.location.href;
    url = RemoveParamInURL(url, "op", "");
    if ("undefined" != typeof (GetParamInURL("ver"))) {
      url = RemoveParamInURL(url, "ver");
    }
    window.location.href = url;
  }
}
function ChkExportedVersion(VerList, EDocID, ChkLockID) {
  var s_res = {};
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/EDocument.asmx/CheckVersionStateForExport" + WSSParam,
    data: "{'EDocID':'" + EDocID + "', 'VerNum':'" + VerList.value + "', 'IsExport':'true'}",
    async: false,
    cache: false,
    success: function (res) {
      if (!CheckForLoginPage(res.d)) {
        s_res = res.d;
        if (!!s_res.Warning) HintShow(s_res.Warning);
        if (s_res.Error != '') { WrnShow(s_res.Error) }
        var enableLock = s_res.EnableLock == 'true';
        var el = $("#" + ChkLockID);
        if (enableLock) {
          el.removeAttr('disabled');
        } else {
          el.attr('disabled', 'disabled').prop('checked', false);
        }
      }
    }
  });
}
// Импорт и создание документа
function GetImgByExt(ext) {
  var R;
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/EDocument.asmx/GetImgByExt" + WSSParam,
    data: "{'Extension':'" + ext + "'}",
    async: false,
    cache: false,
    success: function (res) {
      R = res.d;
    }
  });
  CheckForLoginPage(R);
  return R;
}
// Импорт
function CloseImportDlg() {
  UnbindBeforeUnload();
  var EDocID = GetParamInURL("id");
  FreeEDoc(EDocID);
  if (document.referrer.toLowerCase().indexOf("explorer.aspx") != -1 || GetParamInURL("place").toLowerCase().indexOf("explorer") != -1) {
    window.close();
  } else {
    var url = window.location.href;
    url = RemoveParamInURL(url, "op", "");
    if ("undefined" != typeof (GetParamInURL("ver"))) {
      url = RemoveParamInURL(url, "ver");
    }
    url = RemoveParamInURL(url, "mode");
    window.location = url;
  }
}
// Общие
function BaseCloseDocWindow(edocId) {
  window.onunload = function () { FreeEDoc(edocId); };
}
function FreeEDoc(EDocID) {
  var R;
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/EDocument.asmx/FreeEDoc" + WSSParam,
    data: "{'EDocID':'" + EDocID + "'}",
    async: false,
    success: function (res) {
      R = res.d;
    }
  });
  CheckForLoginPage(R);
  return R;
}
/* =================================================================================================================================================== */

/* =Папки============================================================================================================================================= */
function ShowFolderCard() {
  DoAction('view=Card&-UpdateExplorer', false);
}
function ShowFolderRights() {
  DoAction('view=RightsList&-UpdateExplorer', false);
}
function UndoFolderCard() {
  UnbindBeforeUnload();
  DoAction('__POSTBACK_ACTION=Undo&-UpdateExplorer', true);
}
function EnterEditMode_FolderCard() {
  var mode = GetParamInURL("mode");
  if (mode.toLowerCase() == "edit") {
    DoAction("mode=read&-UpdateExplorer", false);
  } else {
    DoAction("mode=edit&-UpdateExplorer", false);
  }
}



function ChangeTabFolder(tabName) {
  ShowTopSpinner(L("PLEASE_WAIT"), false);
  if (tabName != 'RightsList') {
    if (!IsRightsListValid()) {
      ErrorShow(L("WARN_EMPRY_RIGHTS_ISNOT_VALID"), true);
    } else {
      DoAction('view=' + tabName + '&-op&-val&-ver&-ShowAll', false);
    }
  } else {
    DoAction('view=' + tabName + '&-op&-val&-ver&-ShowAll', false);
  }
}

function BaseCloseFolderCardWindow(folderId) {
  window.onunload = function () { FreeFolder(folderId); }
}
function FreeFolder(folderId) {
  var R;
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/Folder.asmx/FreeFolder" + WSSParam,
    data: "{'FolderID':'" + folderId + "'}",
    async: false,
    success: function (res) {
      R = res.d;
    }
  });
  CheckForLoginPage(R);
  return R;
}
function SaveFolderCard(need_close, noCheckSubObj) {
  var FolderKind = $('#hiddctl00_MainContent_ctl00_Kind').val();
  var FolderID = WA.CR.ID;

  // В мобильной версии права применять только к папке.
  if (WA.isMobile())
    noCheckSubObj = true;

  if (!IsRightsListValid()) {
    HideTopSpinner();
    ErrorShow(L("WARN_EMPRY_RIGHTS_ISNOT_VALID"), true);
    return;
  } else {
    if (!noCheckSubObj && (!WA.isMobile() && WA.CR.sideBar.tabs.current.name === "RightsList")) {
      var selectedUsers = $('input[name=__SELECTED_USERS]').val();
      var currentRights = $('input[name=__CURRENT_USERS_RIGHTS]').val();

      if (selectedUsers !== currentRights) {
        if (!checkCurrentUserRights()) {
          var dialog = new WA.CMP.dialogs.MessageBox();

          var mainText = L('NO_FOLDER_FULL_RIGHTS')
          var additionalText = L('NO_FOLDER_FULL_RIGHTS_ADDITIONAL');
          var title = L('WARNING');

          dialog.removeDefaultButtons();
          dialog.addButton('Continue', L('PROCEED_SAVING'), function () {
            saveRightsByService(FolderID, need_close);
          });
          dialog.addButton('RestoreRights', L('RESTORE_RIGHTS'), function () {
            // Восстанавливаем полные права текущему пользователю
            $('input[name=__SELECTED_USERS]').val(selectedUsers + ';' + CurrentUserID + '-0');
            saveRightsByService(FolderID, need_close);
          });
          dialog.addButton('Cancel', L('CANCEL'), function () { });

          dialog.show(mainText, additionalText, title, 'warning');
        } else {
          saveRightsByService(FolderID, need_close);
        }
        return;
      }
    }
  }

  // пошлем запрос на сервер о необходимости задать вопрос пользователю.
  if (FolderKind != null && FolderID != "") {
    // отобразим ожидание.
    if (typeof (ShowTopSpinner) != 'undefined') ShowTopSpinner(L("PLEASE_WAIT"));

    var WSSParam = GetWSSParam(location.href, true);
    $.ajax({
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      url: "/Folder.asmx/CheckFolderType" + WSSParam,
      data: "{'FolderID':'" + FolderID + "', 'FolderKind':'" + FolderKind + "'}",
      cache: false,
      success: function (res) {
        if (!CheckForLoginPage(res.d)) {
          SaveFolderCard_WithQuestions(res.d, need_close);
        }
      }
    });
    return;
  }

  SaveFolderCard_WithQuestions(null, need_close);
}

function SaveAndCloseFolder() {
  SaveFolderCard(true);
}

function SaveFolderCard_WithQuestions(msg, need_close) {
  if (typeof (HideTopSpinner) != 'undefined') HideTopSpinner("", 1);

  function ok() {
    UnbindBeforeUnload();
    DoAction(format('__POSTBACK_ACTION={0}&-UpdateExplorer', need_close ? 'SaveAndClose' : 'Save'), true);
  }

  function cancel() {
    $('div.saving').hide();
  }

  if (msg == null) {
    ok();
  } else {
    ConfirmDialogNew(msg, ok, cancel);
  }
}

function saveRightsByService(folderID, needClose) {
  // проверим, не пустая ли папка
  WA.SRV.call('/Folder.asmx/GetContentCount', { "FolderID": folderID }).done(function (res) {
    if (res > 0) {
      // Если есть вложенные элементы, узнаем, надо ли изменять на них права.
      rightsToSubObjectsDialog(needClose);
    } else {
      SaveFolderCard(needClose, true);
    }
  });
}

function rightsToSubObjectsDialog(need_close) {
  var rightsDialog = new WA.CMP.dialogs.MessageBox();

  var mainText = L('APPLY_ACCESS_RIGHTS_TEXT');
  var additionalText = L('APPLY_ACCESS_RIGHTS_LONG_TIME');
  var title = L('CONFIRMATION');

  rightsDialog.removeDefaultButtons();
  rightsDialog.addButton('ApplyReplace', L('YES'), function () {
    applyRights(true);
  });
  rightsDialog.addButton('ApplyNoRepalce', L('APPLY_ACCESS_RIGHTS_YES_REPLACE'), function () {
    applyRights(false);
  });
  rightsDialog.addButton('NoApply', L('NO'), function () { SaveFolderCard(need_close, true); });

  rightsDialog.show(mainText, additionalText, title, 'question');

  function applyRights(isNeedReplace) {
    var selectedUsers = $('input[name=__SELECTED_USERS]').val();
    var currentRights = $('input[name=__CURRENT_USERS_RIGHTS]').val();
    var wdialog = waitDialog();

    wdialog.show();
    WA.SRV.call('/Folder.asmx/ApplyRightsToFolder', {
      FolderID: WA.CR.ID,
      NewUserRights: selectedUsers,
      OldUserRights: currentRights,
      NeedReplace: isNeedReplace
    }).done(function (res) {
      wdialog.close();
      resultDialog(res);
    }).fail(function (res) {
      wdialog.close();
      resultDialog(res);
    });
  };

  function waitDialog() {
    var dialog = new WA.CMP.dialogs.BaseDialog();
    dialog.removeDefaultButtons();
    dialog.removeCloseButton();
    dialog.title = L('APPLY_ACCESS_RIGHTS_PROGRESS_TITLE');
    dialog.setHtml(format('<img src="/images/spinner.gif" style="vertical-align: -10%; margin-right: 10px" /><span id="spinnerText">{0}</span>', L('PLEASE_WAIT_DONT_CLOSE_PAGE')));

    return dialog;
  };

  function resultDialog(res) {
    var dialog = new WA.CMP.dialogs.MessageBox();
    if (res) {
      dialog.mainText = L('APPLY_ACCESS_RIGHTS_ERROR')
      dialog.additionalText = res;
      dialog.onClose = function () {
        UnbindBeforeUnload();
        window.location.reload();
      };
      dialog.showError();
    } else {
      // перезагрузить страницу
      UnbindBeforeUnload();
      window.location.reload();
    }
  };
}

// Проверяет, не забрал ли пользователь полные права у себя
function checkCurrentUserRights() {
  var selectedUsers = $('input[name=__SELECTED_USERS]').val();
  var currentRights = $('input[name=__CURRENT_USERS_RIGHTS]').val();

  var oldRights = parseRightsList(currentRights);
  var maxRights = null;
  var hasFullRights = false;

  for (var i = 0; i < oldRights.length; i++) {
    if (oldRights[i].id == CurrentUserID) {
      maxRights = oldRights[i].rightsType;
      break;
    }
  }

  if (maxRights) {
    var newRights = parseRightsList(selectedUsers);
    for (var i = 0; i < newRights.length; i++) {
      if (newRights[i].id == CurrentUserID) {
        hasFullRights = true;
        break;
      }
    }
  } else {
    // Если записи с текущим ИД не найдено, значит права были выданы неявно
    hasFullRights = true;
  }

  return hasFullRights;
}

function parseRightsList(rights) {
  var result = [];

  var rightsArray = rights.split(';');
  for (var i = 0; i < rightsArray.length; i++) {
    var user = rightsArray[i].split('-');
    result.push({ id: user[0], rightsType: user[1] });
  }

  return result;
}
/* =================================================================================================================================================== */

/* =Поиски============================================================================================================================================= */
function DisableIsAllCheckboxNotChecked(reqname, el_query) {
  var tbl = $('.Search_Table');
  // Для глобального поиска надо false, для остальных true
  var defaultFlag = true;
  if ($("#SrchGeneralAreaT").length > 0 || $("#SrchGeneralAreaC").length > 0 || $("#SrchGeneralAreaN").length > 0
      || $("#SrchGeneralObjectE").length > 0 || $("#SrchGeneralObjectW").length > 0 || $("#SrchGeneralObjectF").length > 0)
    defaultFlag = false;

  var searchAreaText = $("#SrchGeneralAreaT").length > 0 ? $("#SrchGeneralAreaT")[0].checked : defaultFlag;
  var searchAreaCard = $("#SrchGeneralAreaC").length > 0 ? $("#SrchGeneralAreaC")[0].checked : defaultFlag;
  var searchAreaName = $("#SrchGeneralAreaN").length > 0 ? $("#SrchGeneralAreaN")[0].checked : defaultFlag;
  var searchObjEDocument = $("#SrchGeneralObjectE").length > 0 ? $("#SrchGeneralObjectE")[0].checked : defaultFlag;
  var searchObjCustomWork = $("#SrchGeneralObjectW").length > 0 ? $("#SrchGeneralObjectW")[0].checked : defaultFlag;
  var searchObjFolder = $("#SrchGeneralObjectF").length > 0 ? $("#SrchGeneralObjectF")[0].checked : defaultFlag;
  var $archiveTag = $("#Search").find('input[id$=SrchGeneralPseudoArchiveTag]');
  //var isInvalidCriteria = (searchObjFolder && !searchObjCustomWork && !searchObjEDocument) && (searchAreaText && !searchAreaCard);
  //if (!isInvalidCriteria)
  //  isInvalidCriteria = (!searchObjFolder && !searchObjCustomWork && !searchObjEDocument);
  if (tbl.length == 0) {
    tbl = $('div.card');
  }
  //var el = tbl.find(el_query);
  var txt = tbl.find("input[id*=Text]");
  var btn = tbl.find("input.Search_Btn:first");
  var Warning = $(btn).prev("div#SrchWarnMsg");

  var DisableButton = false;
  var DisableTextbars = false;

  if (!searchObjFolder && !searchObjCustomWork && !searchObjEDocument) {
    DisableButton = true;
  } else if (!searchObjFolder && !searchObjCustomWork && !searchObjEDocument && !searchAreaCard) {
    DisableButton = true;
  } else if (searchObjFolder) {
    DisableButton = false;
  }

  if (!searchAreaText && !searchAreaCard && !searchAreaName) {
    DisableTextbars = true;
  }
  // поиск папок по тексу это неверные критерии
  if (searchAreaText && searchObjFolder && !searchAreaCard && !searchObjCustomWork && !searchObjEDocument) {
    DisableButton = true;
  }

  //Отключаем элементы
  //if ((tbl.find('input[id*=' + reqname + ']:checked').length == 0) || (isInvalidCriteria)) {
  if (DisableButton) {
    var htmlWarning = "<div id='SrchWarnMsg' class='ui-state-highlight ui-corner-all error_div_msg'>" +
                                "<p id='errp'><span class='ui-icon ui-icon-alert'></span>" +
                                    L("WARN_INVALID_SEARCH_CRITERIA") +
                                "</p></div>";
    //Добавляем сообщение
    if (Warning.length == 0) $(btn).before(htmlWarning);
    //блокируем кнопку
    btn.attr("disabled", true);
    btn.addClass('disabled');
  } else {
    //удаляем сообщение
    if (Warning.length > 0) Warning.remove();
    //снимаем блокировку с кнопки
    btn.removeAttr("disabled");
    btn.removeClass('disabled');
  }

  if (DisableTextbars) {
    //блокируем текстовые поля
    txt.attr("disabled", true);
    txt.addClass('Req_Disabled');
  } else {
    //снимаем блокировку с текстовых полей
    txt.removeAttr("disabled");
    txt.removeClass('Req_Disabled');
  }
}
function DisableTextbox(reqname) {
  //DisableIsAllCheckboxNotChecked(reqname, 'input[id*=Text]');
  DisableIsAllCheckboxNotChecked(reqname, 'input.Search_Btn:first');
}
function DisableSearchBtn(reqname) {
  DisableIsAllCheckboxNotChecked(reqname, 'input.Search_Btn:first');
}
function SearchPseudoArchiveTagChanged(reqname) {
  DisableIsAllCheckboxNotChecked(reqname, 'input.Search_Btn:first');
}
/* =================================================================================================================================================== */

/* =Мастера действий============================================================================================================================================= */
function CloseBaseWizardWindow(key) {
  window.onunload = function () { FreeWizard(key); }
}

function FreeWizard(key) {
  var R;
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/Wizard.asmx/FreeWizard" + WSSParam,
    data: "{'Key':'" + key + "'}",
    async: false,
    success: function (res) {
      R = res.d;
    }
  });
  CheckForLoginPage(R);
  return R;
}

function DisableWizardButtons() {
  $('.wizard-form__button').addClass('disabled').attr('disabled', 'disabled');
}

// на этапе мастера типа запись справочника и установке автоматически открывать запись справочника - будет открываться вкладка.
function OpenObjectInWizardStep(notAutomatically) {
  var jShowRefCard = $("#ObjectHyperlink");

  if (jShowRefCard.length > 0) {
    if (jShowRefCard.data('hasaccess') == 'True') {
      if (jShowRefCard.data('autoshow') == 'True') {
        var id = jShowRefCard.data('id');
        var versionNum = jShowRefCard.data('version');
        var hasVersions = jShowRefCard.data('hasversions') == "True";

        if (WA.agent.isAvailable() && (typeof versionNum !== 'undefined') && ('' + versionNum !== '0') && g_defaultListAction !== "preview") {
          if (hasVersions) {
            var openForWrite = false;
            if (jShowRefCard.data('openforwrite') == "True") {
              openForWrite = true;
            }

            // Если режим открытия документа - тело
            var docLink = new WA.Link(id, OBJECT_TYPE.EDOCUMENT);
            if (jShowRefCard.data('showmode') == WIZARD_DOCUMENT_STEP_SHOW_MODE.BODY) {
              Core.agent.getPlugin('edmsplugin').done(function () {
                SendEDocToAgent(id, versionNum, openForWrite);
              }).fail(function () {
                if (notAutomatically) {
                  docLink.open();
                }
              });
            }
            else {
              // Если режим открытия документа - карточка
              docLink.open();
            }
          }
          else {
            //отобразить сообщение что недоступна версия
            ConfirmDialog({ title: L("INFO"), text: L("ERR_NO_VERSIONS_AVAILIBLE", jShowRefCard.html()), okText: L("OK"), height: "auto", width: "300px", isShowCancelButton: false });
          }
        }
        else {
          jShowRefCard.click();
        }
      }
    }
    else {
      // Вывести сообщение об отсутствии прав
      ShowError(L("OBJECT_NOT_ACCESS_OR_CREATE"));
    }
  }
}
/* =================================================================================================================================================== */

var CallService, CallServiceSync;

(function () {

  // Функция, чтобы вызывать методы сервисов веб-доступа. Давно нужна была!
  // string service_method: метод сервиса, например /Session.asmx/CopyLinks
  // [object params]: параметры
  // [function callback(res)]: функция, вызываемая при успешном завершении запроса.
  //     object res: объект, который вернул сервис.
  function CallServiceInternal(service_method, params, callback, error, async) {
    params = params || {};
    var error_handler = function () { if (error) error.apply(null, arguments); }
    $.ajax({
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      url: service_method,
      data: $.toJSON(params),
      async: async,
      cache: false,
      success: function (res) {
        if (!res) {
          error_handler();
          return;
        }
        res = res.d;
        if (CheckForLoginPage(res)) return;
        if (typeof callback !== "undefined")
          callback(res);
      },
      error: error_handler
    });
  }

  CallService = function (service_method, params, callback, error) {
    CallServiceInternal(service_method, params, callback, error, true);
  }

  CallServiceSync = function (service_method, params, callback, error) {
    CallServiceInternal(service_method, params, callback, error, false);
  }

})();

// ==========================================================================================================
// Супер-функция. Обрабатывает все нажатия на все табы во всех карточках объектов (в идеале).
// string tabName - название вкладки.
function CardTabClick(tabName) {
  var changeTab = function () {
    ShowTopSpinner(L("PLEASE_WAIT"), false);
    if (page == "/reference.aspx") {
      UnbindBeforeUnload();
    }
    DoAction('view=' + tabName + '&-op&-val&-ver&-ShowAll', false);
  };

  if (tabName == 'Card' && $('.CardForm_Tab').length) { // мы в карточке документа, например
    Core.sideBar.updateTab(1);
  } else {
    var page = window.location.pathname.toLowerCase();
    if (page.indexOf("/doc.aspx") !== -1)
      ChangeTabDoc(tabName);
    else if (page.indexOf("/folder.aspx") !== -1)
      ChangeTabFolder(tabName);
    else if (page == "/reference.aspx" && (!GetParamInURL('view') || GetParamInURL('view').toLowerCase() == 'card')) {
      if ($('#toolbar_container [name="RefCardSave"]').length) {
        WA.CR.form._saveExtended(changeTab, false, 0, {
          needShowError: false
        });
      } else {
        changeTab();
      }
    }
    else
      changeTab();
  }
}

function leadzero(x) {
  return (x < 10) ? '0' + x : x;
}

/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

function ShowAllCustomWorkState() {
  DoAction('ShowAll=1');
  return false;
}

function ReloadExplorer() {
  WA.CR.window.reloadExplorer();
}

function PageInit() {
  $(function () {
    $(window).resize(function () { setRealHeightAndWidthOnResize(); });
    setRealHeightAndWidth();
    initCollapsableElements();
    InitMouseEvents();
    InitTooltips();
  });
  jQuery().pagezoom(function () {
    setTimeout(function () {
      setRealHeightAndWidth();
    }, 150);
  });
}


function RefSel_AttachResult(inp, data, id, AfterSelectFunc, IsNeedCallFuncOnClr, leader, driven) {
  if (data != null) {
    if ($.isFunction(AfterSelectFunc)) AfterSelectFunc(data[0]);

    var needFillLeadAndDriven = (leader.length > 0 || driven.length > 0);
    if (needFillLeadAndDriven) {
      ClrVal(id, true, driven);
      g_FillLead[id] && g_FillLead[id](data[3]);
      g_FillDriven[id] && g_FillDriven[id]();
    }

    inp.change();
  } else {
    //вызываем функцию если поле очищено
    if (IsNeedCallFuncOnClr) AfterSelectFunc(null);
    ClrVal(id, false, driven);
  }
}

function RefSel_AttachMultiResult(inp, data, AfterSelectFunc) {
  if (AfterSelectFunc != null) AfterSelectFunc(inp, data);
}

var g_GetLeadSelIDs = {};
var g_FillLead = {};
var g_FillDriven = {};

function BindLeaderDrivenRequisites(id, leader, lookup, driven) {

  //Получим значения ведущих реквизитов.
  g_GetLeadSelIDs[id] = function () {
    var val = '';
    for (var i = 0; i < leader.length; i++) {
      var leaderParts = leader[i].split("|");
      var leaderControlName = leaderParts[0];
      var leaderRequisiteName;
      if (leaderParts.length === 1) {
        leaderRequisiteName = '';
      } else {
        leaderRequisiteName = leaderParts[1];
      }

      val += lookup[i] + '|' + leaderRequisiteName + '=' + getValue(leaderControlName) + '&';
    };
    return val;
  };

  // Заполним ведущие реквизиты.
  g_FillLead[id] = function (LeadIDs) {
    var ht = $.parseJSON(LeadIDs);

    for (var i = 0; i < leader.length; i++) {
      var leaderData = ht[lookup[i]];
      var leaderControlName = leader[i].split("|")[0];

      if (!$.isEmptyObject(leaderData)) {
        var inp = $('input#' + leaderControlName);
        if (inp.length > 0) {
          var rs = inp.data('ReferenceSelectInstance');
          var refCode = rs.getFirstRefCode();

          var queryContext = rs.queryContext;
          // Множественный выбор ссылается на несколько ревизитов, поэтому меняем контекст.
          if (rs.referenceCodesAndReqNamesInDetailSection && rs.referenceCodesAndReqNamesInDetailSection[refCode]) {
            queryContext = JSON.parse(queryContext);
            queryContext.requisiteNumber = rs.referenceCodesAndReqNamesInDetailSection[refCode].number;
            queryContext = JSON.stringify(queryContext);
          }

          var url = rs.url;
          var params = $.extend({
            q: "",
            filter: "[ИД]=" + leaderData[0],
            useadditional: rs.useadditional ? "1" : "0",
            disablespecialprocessing: "1",
            queryContext: queryContext
          }, rs.extraParams || {});

          rs.dataProvider.sendQuery(url, params, (function (_leaderControlName) {
            return function (count, res) {
              var data = res[0];
              if (data && data.leadingRequisitesValue !== "{}") {
                g_FillLead[_leaderControlName](data.leadingRequisitesValue);
              }
            };
          })(leaderControlName));
        }

        $('#' + leaderControlName).SetValue(leaderData).change();
      }
    };
  };

  // Вызовем функции автозаполнения у ведомых реквизитов.
  g_FillDriven[id] = function () {
    try {
      for (var i = 0; i < driven.length; i++) {
        FillDrivenIfItResultHasOneRecord(driven[i], g_GetLeadSelIDs[driven[i]]);
      };
    } catch (ex) { }
  };

};

//Очистка значений реквизитов
function ClrVal(ID, ClrOnlyDriven, DrivenIDs) {
  var IDs = [];
  var CurentID;
  try {
    if (ClrOnlyDriven) IDs = IDs.concat(DrivenIDs);
    else IDs = IDs.concat(ID, DrivenIDs);
    for (i = 0; i < IDs.length; i++) {
      CurentID = IDs[i];
      var inp = $("#" + CurentID);
      inp.SetValue(null).change();
    }
  } catch (ex) { }
}

// Получение значение реквизита
function getValue(reqID, inp) {
  var v = $('#hSelID_' + reqID).val();
  return (typeof v == 'undefined' ? '' : v);
}

function FillDrivenIfItResultHasOneRecord(id, LeadSelIDs) {
  var refurl = $("#" + id).attr("refurl");
  $("#" + id).Clear();
  $.ajax({
    type: "GET",
    dataType: "text",
    url: refurl + "&LeadSelID=" + encodeURI(LeadSelIDs()),
    cache: false,
    success: function (res) {
      var rows = res.split("\r\n");
      if (rows.length > 0 && rows[0] != 'ERROR' && rows.length == 3) {
        $("#" + id).SetValue(rows[1].split('|')).change();
      }
    }
  });
}

// Инициализируем подсказки для реквизита выбора из справочника.
function RefSel_InitHint(el, RefSelID, RefCode) {
  var inpId = el.attr('id');
  el.addClass('hint').data('data-hint', { id: RefSelID, compcode: RefCode }).removeClass('hintInit').qtip('hide');

  function updateHintData($this, newRecID, RefCode) {
    if (newRecID != null && newRecID != '') {
      $this.data('data-hint', { id: newRecID, compcode: RefCode })
      $this.removeClass('hintInit').qtip('hide');
      InitAdditionalInfoTooltip($this);
    } else {
      $this.removeData('data-hint').removeClass('hintInit').qtip('hide').qtip('disable');
    }
  }

  el.bind('onSelected', function () {
    updateHintData($(this), $('#hSelID_' + inpId).val(), RefCode);
  });
  el.result(function (event, data) {
    updateHintData($(this), (data != null ? data[0] : null), RefCode);
  });
}

var OnTabChanged = function (callback, tabName, dfmTabName) {
  if (tabName === 'Card') dfmTabName = 'Card';

  var SB = WA.CR.sideBar;
  //TODO Шамов А.: События должны fire внутри класса, а не где попало.
  if (SB) SB.fire(SB['class'].EVENT.BEFORE_TAB_SWITCH, SB.tabs[tabName]);

  var isRun = false;
  var callbackRunChecker = function () {
    var r;
    if (callback) {
      r = callback();
    }
    isRun = true;
    return r;
  };
  dfmTabName = dfmTabName || '';

  var htmlEl = $('div.tab_item').filter('[id$=_' + tabName + ']');

  var result = $('html').triggerHandler('OnTabChanged', [tabName, dfmTabName, callbackRunChecker, htmlEl]);
  if (!isRun && (typeof result == 'undefined' || result)) {
    callbackRunChecker();
  }
  //TODO Шамов А.: События должны fire внутри класса, а не где попало.
  if (SB) SB.fire(SB['class'].EVENT.AFTER_TAB_SWITCH, SB.tabs[tabName]);
}

/**
* Преобразует специальные символы в HTML сущности
* @function HTMLEncode
* @global
* @param {string} text
* @return {string}
* @deprecated
*/
function escapeHtml(text) {
  return ('' + text).escapeHtml();
};

/**
* Используется в WebAccess для проверки наличия биндингов, не удаляйте пожалуйста(один раз уже пропало)
* @function jQuery.hasAttr
* @param {string} name
* @return {boolean}
*/
$.fn.hasAttr = function (name) {
  return this.attr(name) !== undefined;
};

/**
* Поиск объекта в массиве по атрибуту
* @function getElementIndexByAttr
* @global
* @param {array} array массив объектов
* @param {string} key атрибут по которому ищется объект
* @param {string} value значение атрибута
* @return {integer} индекс найденного элемента, либо -1 если не найден
*/
getElementIndexByAttr = function (array, key, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i][key] === value) {
      return i;
    };
  };
  return -1;
};

/**
* Возможность перезаписи функций, с возможностью запуска родительской функции.
* @global
*/
Function.prototype.override = function (func) {
  var superFunction = this;
  return function () {
    this.superFunction = superFunction;
    return func.apply(this, arguments);
  };
};

// Показать модальное окно с инструкцией
function showInstructionDialog() {
  WA.services.call("/Task.asmx/GetInstruction", { "Type": WA.getLocation(), "ID": GetParamInURL("id") }).success(function (result) {
    var dialog = new WebAccess.components.dialogs.BaseDialog();
    dialog.setHtml(this.Result.html);
    dialog.width = '600px';
    dialog.height = 'auto';
    dialog.title = this.Result.title;
    dialog.okText = L("CLOSE");
    dialog.show();
    BindHelpIcoClickOnModalWindow('Instruction');
  }).error(function (error) {
    console.log(error);
  });
}

/**
* Поиск предка для элемента
*/
$.fn.hasAncestor = function (a) {
  return this.filter(function () {
    return !!$(this).closest(a).length;
  });
};

/**
* Стандартный метод when jquery резолвится сразу как только зафейлится первый из деферредов.
* Этот метод дожидается всей пачки переданных deferred-объектов и только тогда вызывается done или fail;
*/
$.whenAllDone = function () {
  var deferreds = [];
  var result = $.Deferred();

  $.each(arguments, function (i, current) {
    var currentDeferred = $.Deferred();
    current.then(function () {
      currentDeferred.resolve(false, arguments);
    }, function () {
      currentDeferred.resolve(true, arguments);
    });
    deferreds.push(currentDeferred);
  });

  $.when.apply($, deferreds).then(function () {
    var failures = [];
    var successes = [];

    $.each(arguments, function (i, args) {
      // If we resolved with `true` as the first parameter
      // we have a failure, a success otherwise
      var target = args[0] ? failures : successes;
      var data = args[1];
      // Push either all arguments or the only one
      target.push(data && data.length === 1 ? data[0] : args);
    });

    if (failures.length) {
      return result.reject.apply(result, failures);
    }

    return result.resolve.apply(result, successes);
  });

  return result;
};

/**
* Способ для определения того,
* что браузер был перезапущен для браузеров которые не грохают сессионные куки
* @see #93027
*/
(function emulateSession() {
  var cookieName = 'fakeSession';
  var sessionId = new Date().getTime();
  var keepAliveLoop = null;

  var getSession = function () {
    return $.cookie(cookieName);
  }

  var setSession = function () {
    var options = { expires: new Date((new Date).getTime() + 5 * 1000) };
    $.cookie(cookieName, sessionId, options);
  };

  var runSession = function () {
    var me = this;
    var seconds = 2 * 1000;
    var keepAlive = function () {

      if (getSession()) setSession();
      else if (WA.getLocation() !== 'login') {
        browserSessionIsRestored = true;
      };
    };

    if (!keepAliveLoop) keepAliveLoop = setInterval(keepAlive, seconds);
    keepAlive();
  };

  if (WA.getLocation() === 'login') setSession();

  else setTimeout(function () {
    browserSessionIsRestored = false;
    setSession();
  }, 100);

  runSession();
})();

/* DEPRECATED */
(function () {
  window._isDarkTheme = function () {
    return false;
  };

  window._prefixIfDark = function () {
    return '';
  };
})();
